import * as React from "react";
import {LinearProgress} from "@mui/material";
import {useParams} from "react-router-dom";
import {ActionType} from "../../components/quickform/Model";
import {QuickForm} from "../../components/quickform/QuickForm";
import {PubSub} from "../../components/PubSub";
import Page from "../../layout/Page";
import PageContent from "../../layout/PageContent";
import PageHeader from "../../layout/PageHeader";
import {ParamLogisticsPartner} from "../../Parameters";
import {SavingUI} from "../../SavingProvider";
import {
   useLogisticsPartnerSettingsPageQuery,
   useLogisticsPartnerSettingsPageUpdateMutation
} from "../../Queries";
import {createLogisticsPartnerForm, LogisticsPartnerFormData} from "./LogisticsPartnerForm";

const settingsForm = createLogisticsPartnerForm({
   title: "Logistics partner details",
   credentials: true
});

export const LogisticsPartnerSettingsPagePath = (logisticsPartnerId: string) => {
   return `/logisticspartners/${logisticsPartnerId}/settings`;
}

export const LogisticsPartnerSettingsPage = () => {
   const {logisticsPartnerId} = useParams<ParamLogisticsPartner>();
   const {data, loading} = useLogisticsPartnerSettingsPageQuery({
      variables: {
         id: logisticsPartnerId
      }
   });
   const [updatePartner] = useLogisticsPartnerSettingsPageUpdateMutation();

   if (loading || !data?.LogisticsPartner) {
      return <LinearProgress/>;
   }

   const partner = data.LogisticsPartner;

   const onButton = async (action: ActionType, formData: LogisticsPartnerFormData) => {
      if (action === "save") {
         await SavingUI.process(async () => {
            await updatePartner({
               variables: {
                  id: logisticsPartnerId,
                  input: {
                     name: formData.name,
                     attention: formData.attention,
                     address: formData.address,
                     address2: formData.address2,
                     zipCode: formData.zipCode,
                     city: formData.city,
                     country: formData.country,
                     countryCode: formData.countryCode,
                     mail: formData.mail,
                     phone: formData.phone,
                     apiKey: formData.apiKey,
                     apiSecret: formData.apiSecret
                  }
               }
            });
            PubSub.emit("NavigationReload");
         }, "Logistics partner updated");
      }

      return {success: true};
   }

   return <Page>
      <PageHeader title={`${partner.name || "Logistics partner"} settings`} onBack/>
      <PageContent>
         <QuickForm form={settingsForm} data={partner} onButton={onButton}/>
      </PageContent>
   </Page>
}
